import { useCoreFontProgress } from './coreFonts'
import { navigateHash } from './navigate'

/**
 * 等乐谱字体时的整页态 —— 只有真要画谱的路由（`#edit` / `#share`）才看得到。
 *
 * 版式**逐像素照抄** `index.html` 里那个静态首屏态：还是 `padding: 24px`、左上角对齐、
 * 同一套 `--ld-*` 变量。React 的首次提交会把静态首屏态整个清掉，两屏几何一致，
 * 交接才看不出接缝 —— 顺手"改成居中"就是另一件事了，不在这轮里做。
 *
 * 那组 `--ld-*` 由 `index.html` 的 `<style>` 定义在 `:root` 上（它的注释说明了
 * 为什么必须写死颜色：此刻 GlobalStyle 的 `--paper` 等还不存在）。
 * 应用挂载后那几条**依然有效**，GlobalStyle 注入的是另一套名字，不会互相覆盖 ——
 * 所以这里可以直接引用，而不必把那份调色板再抄一遍。
 *
 * `data-core-font-splash` 是给构建后的浏览器探针用的：无头 Chrome 里"现在卡在哪一屏"
 * 从文字判断不可靠（静态首屏态、这里、`加载中…` 都是整页态），得有个明确的抓手。
 */
export function CoreFontSplash() {
	const {progress, total} = useCoreFontProgress()

	return <div data-core-font-splash style={{padding: 24}}>
		<p style={{margin: '0 0 12px'}}>正在载入乐谱字体⋯⋯</p>
		<p style={{display: 'flex', flexDirection: 'row', width: '100%', maxWidth: 400, margin: 0}}>
			<span style={{
				background: 'var(--ld-track)',
				flex: 'auto',
				position: 'relative',
				borderRadius: 3,
				overflow: 'hidden',
			}}>
				<span style={{
					position: 'absolute',
					display: 'block',
					height: '100%',
					width: `${total > 0 ? (progress / total * 100) : 0}%`,
					background: 'var(--ld-bar)',
					transition: 'width .2s',
				}} />
			</span>
			{/* 左边那条轨道没有自己的高度，靠这个兄弟节点撑出弹线的行高 —— 所以
			    即使 total 还没上报也不能是空串，否则整条进度条会塌成 0 高 */}
			<span style={{
				marginLeft: 8,
				flex: 0,
				minWidth: '2.5em',
				color: 'var(--ld-ink-3)',
				fontVariantNumeric: 'tabular-nums',
			}}>{total > 0 ? `${progress}/${total}` : '…'}</span>
		</p>
		{/*
		 * 一条退路。字体要是**永远**加载不出来（离线、CDN 挂了、字体目录没部署上），
		 * 这一屏就是 `#edit` 的死胡同 —— 而用户完全可能是刚在指南里点了
		 * 「在编辑器中打开」过来的，身后那页本来是好好的。
		 *
		 * 退路只能是**离开**，绝不能是"照样渲染"：见 `coreFonts.ts` 顶部第 2 条，
		 * 拿回退字形画一遍会永久毒化 `DomPaint` 的 measure 缓存，比空白更糟。
		 */}
		<p style={{margin: '12px 0 0'}}>
			<button
				type='button'
				onClick={() => navigateHash('')}
				style={{
					appearance: 'none',
					border: 0,
					padding: 0,
					background: 'none',
					color: 'var(--ld-ink-3)',
					fontFamily: 'inherit',
					fontSize: 13,
					textDecoration: 'underline',
					cursor: 'pointer',
				}}
			>返回首页</button>
		</p>
	</div>
}
